import React, { useEffect, useState } from 'react' 
import first from '../src/image/ludo.png'
import first2 from '../src/image/popular.webp'
import first3 from '../src/image/goti.webp'
import first4 from '../src/image/ultaLudo.webp'
import Accordion from 'react-bootstrap/Accordion';
import './App.css'
import { NavLink, useNavigate } from "react-router-dom";

import logo from './image/logo.jpg'
import { ProfileProvider } from './ProfileContext'
import { Api_Url } from './APIUrl'



const HomePage = () => {

  
const navigate = useNavigate();
  const [dataone, setDataone] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [name, setName] = useState(""); 
  const [kycStatus, setKycStatus] = useState(""); // Initial status is empty
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState(""); 

  const fetchProfile = async () => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${localStorage.getItem("token")}`);
  
      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };
  
      const response = await fetch(`${Api_Url}api/profile`, requestOptions);
      const result = await response.json();
  
      if (result.success) { 
        setKycStatus(result.data.user.kyc_status);
      } else { 
        // if (result.message === "Token has expired.") { 
        //   localStorage.removeItem("token");
        //   navigate("/");
        //   alert("Your session has expired. Please log in again.");
        // } else { 
        //   alert(result.message );
        // }
      }
    } catch (error) {
      console.error("Error fetching profile:", error);
      alert("Failed to fetch profile. Please try again later.");
    }
  };
  
 

   const handleModal = (message) => {
    setModalMessage(message);
    setModalIsOpen(true);
  };


  // useEffect(() => {
  //   fetchProfile();
  
  //   const interval = setInterval(() => {
  //     fetchProfile();
  //   }, 5000); // Call fetchProfile every 5 seconds
  
  //   return () => clearInterval(interval); // Clean up the interval when the component unmounts
  // }, []);
  
 


  return (
    <div className=''>
       
        <div className='container-fluid mt-5 '>
            <div className='row'>
                <div className='col-lg-12 px-0'>
                <marquee className="py-2"  style={{backgroundColor:'#de3545'}}> 
                  <h6 className='text-center text-white mb-0' >  
                 🎲Brothers ludo🎲 में आपका स्वागत करता है 🙏 हेल्पलाइन नंबर 👉  ( केवल WhatsApp call & message)👈 🙏withdrawal मात्र 2 मिनट में मिलेगा🙏
                   </h6></marquee> 
                
                </div>

               
            </div>


<div className='row'>


            <div className='col-12   '>


            {kycStatus === "pending" ? (
         <div className='card py-0 w-100 my-3 border-0 '  style={{backgroundColor:'#f8f9fa',	boxShadow: 'rgb(255, 104, 104) 0px 0px 3px 1px'
         }}>
             <div className='card-body '>
                 <div className='row'>
                     <div className='col-8'>
                         <p className='my-1 w-100'  style={{color:'#ff0000', fontSize:'12px'}}>Complete KYC to take Withdrawals  </p>
                       </div>  
                     <div className=' col-3'>
                       {/* <div  style={{display:'flex', justifyContent:'start'}}> */}
                       <NavLink to="/ky3"  style={{textDecoration:'none'}}> <button className='btn p-0 p-1' style={{backgroundColor:'#dc3545', color:'#fff', fontSize:'12px', textWrap:'nowrap'}}>Complete KYC</button> </NavLink>
                      {/* </div> */}
                      </div>
         
                 </div>
             </div>
         </div>   
      ) : (
        kycStatus === "approved" || kycStatus === "rejected" ? (
          handleModal(kycStatus === "approved" ? "KYC Approved" : "KYC Rejected")
        ) : null
      )}

  

{/* 
<div className=''>
  <h6  style={{fontSize:'12px'}}>🎲Brothers ludo🎲 में आपका स्वागत करता है 🙏 हेल्पलाइन नंबर 👉.......... ( केवल WhatsApp call & message)👈 🙏withdrawal मात्र 2 मिनट में मिलेगा🙏</h6>
  <h6  style={{fontSize:'12px'}}>COMMISSION 5% : REFERRAL 2% FOR ALL GAMES</h6>
</div> */}


<h5 className='my-3'>Our Games </h5> 
<div className='mx-4 mb-2 mobileviewss'  style={{display:'flex',  justifyContent:'space-between', alignItems:'center'}}>
<p className='mb-0 blinking '  style={{fontSize:'12px', color:'red'}}> Min ₹50 - Max ₹25k ◉ LIVE</p>   
<p className='mb-0 blinking'  style={{fontSize:'12px',color:'#de3545'}}  >Comming Soon</p>   
</div> 

        <div className='row mt-2'>
    <div className='col-6'>
      <div style={{boxShadow:'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px', borderRadius:'10px'}}>
       <NavLink to="/ludoking" style={{textDecoration:'none', color:'#000'}}> <img src={first} alt='#' style={{width:'100%'}}></img>
       
       
       <p className='py-2' style={{textDecoration:'none', color:'#000', textAlign:'center', fontWeight:'500', fontSize:'17px',  color:'#292929'}}>Ludo Classic </p></NavLink>
    </div>
    </div>
    <div className='col-6'>
    <div style={{boxShadow:'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',borderRadius:'10px'}}>
     <img src={first2} alt='#' style={{width:'100%',borderRadius:'20px'}}></img>
       
       
       <p className='py-2 demo2' style={{textDecoration:'none', color:'#000', textAlign:'center', fontWeight:'500', fontSize:'17px',color:'#292929'}}>popular Ludo</p> 
    </div>
    </div>
        
        </div> 

        <div className='row mt-2'>
       
        
    <div className='col-6'>
<p className='mb-0  pb-2 text-center'  style={{fontSize:'12px',color:'#de3545'}}  >Comming Soon</p>   
      <div style={{boxShadow:'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px', borderRadius:'10px'}}>
        <img src={first3} alt='#' style={{width:'100%',borderRadius:'20px'}}></img>
       
       
       <p className='py-2' style={{textDecoration:'none', color:'#000', textAlign:'center', fontWeight:'500', fontSize:'17px',color:'#292929'}}>Goti Ludo</p> 
    </div>
    </div>
    <div className='col-6'>
    <p className='mb-0  pb-2 text-center'  style={{fontSize:'12px',color:'#de3545'}}  >Comming Soon</p>
    <div style={{boxShadow:'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',borderRadius:'10px'}}>
        <img src={first4} alt='#' style={{width:'100%', borderRadius:'20px'}}></img>
       
       
       <p className='py-2 demo2' style={{textDecoration:'none', color:'#000', textAlign:'center', fontWeight:'500', fontSize:'17px',color:'#292929'}}> Ulta Ludo</p> 
    </div>
    </div>
        
        </div> 



        <div className='row mt-4'>
            <div className='col-lg-12'>
            <Accordion defaultActiveKey="1" style={{ border: 'none', boxShadow: 'none', }}>
<Accordion.Item eventKey="0" style={{ border: 'none', boxShadow: 'none' }}>
<Accordion.Header style={{ color: '#959595' }}>
<img src={logo} alt="Logo" style={{ width: '50px', marginRight: '10px' }} />
Terms, Privacy, Support
</Accordion.Header>
<Accordion.Body style={{ border: 'none', boxShadow: 'none' }}>

<div className="row">
<div className="col-6">
<NavLink to="/terms" style={{textDecoration:'none'}}><p style={{ color: '#959595', fontSize:'14px' }}>Terms & Condition</p></NavLink>
  <NavLink to="/RefundPolicy" style={{textDecoration:'none'}}><p style={{ color: '#959595' ,fontSize:'14px'}}>Refund/Cancellation Policy</p></NavLink>
  <NavLink to="/gst" style={{textDecoration:'none'}}><p style={{ color: '#959595' ,fontSize:'14px'}}>GST Policy</p></NavLink>
</div>
<div className="col-6">
<NavLink to="/PrivacyPolicy" style={{textDecoration:'none'}}><p style={{ color: '#959595',fontSize:'14px' }}>Privacy Policy</p></NavLink>
<NavLink to="/support" style={{textDecoration:'none'}}><p style={{ color: '#959595',fontSize:'14px' }}>Contact Us</p></NavLink> 
<p style={{ color: '#959595',fontSize:'14px' }}>Responsible Gaming</p>
</div>
</div>
</Accordion.Body>
</Accordion.Item>
</Accordion>



            </div>
</div>   

   
</div>
</div>
        </div>

        <section  style={{backgroundColor:'#f8f8f8'}}>
        <div className='container-fluid'>
          <div className='row'>
            <div className='col-lg-12'>
            <div className='mt-4'>
      <h6 style={{color:'#959595'}}>About Us </h6>

      <p style={{color:'#959595', fontSize:'14px'}}>Brothersludo is a real-money gaming product owned and operated by Brothersludo ("Brothersludo" or "We" or "Us" or "Our").
      </p>
      <h6 style={{color:'#959595'}}>Our Business & Products  </h6>

      <p style={{color:'#959595', fontSize:'14px'}}>We are an HTML5 game-publishing company and our mission is to make accessing games fast and easy by removing the friction of app-installs.</p>

      <p className='mt-3' style={{color:'#959595', fontSize:'14px'}}>Brothersludo is a skill-based real-money gaming platform accessible only for our users in India. It is accessible on  Brothersludo  On Brothersludo, users can compete for real cash in Tournaments and Battles. They can encash their winnings via popular options such as Paytm Wallet, Amazon Pay, Bank Transfer, Mobile Recharges etc.   </p>


      <h6 style={{color:'#959595', fontSize:'14px'}}>Our Games</h6>

      <p style={{color:'#959595', fontSize:'14px'}}>Brothersludo has a wide-variety of high-quality, premium HTML5 games. Our games are especially compressed and optimised to work on low-end devices, uncommon browsers, and patchy internet speeds.
      </p>
      <p style={{color:'#959595', fontSize:'14px'}}>We have games across several popular categories: Arcade, Action, Adventure, Sports & Racing, Strategy, Puzzle & Logic. We also have a strong portfolio of multiplayer games such as Ludo, Chess, 8 Ball Pool, Carrom, Tic Tac Toe, Archery, Quiz, Chinese Checkers and more! Some of our popular titles are: Escape Run, Bubble Wipeout, Tower Twist, Cricket Gunda, Ludo With Friends. If you have any suggestions around new games that we should add or if you are a game developer yourself and want to work with us, don't hesitate to drop in a line at !
      </p>

    </div>
            </div>
          </div>
        </div>
        </section>
    </div>
  )
}

export default HomePage